import type { ApolloClient } from '@apollo/client'

/**
 * `watchQuery` default shared by the app client and the Storybook decorator so stories run under the
 * same `notifyOnNetworkStatusChange` behavior as the app. Apollo defaults it to `true`, which would
 * drop every refetch, poll and variable change back into `loading`; the app opts in per query instead.
 */
export const apolloWatchQueryDefaults = { notifyOnNetworkStatusChange: false }

export const apolloDefaultOptions = {
  watchQuery: apolloWatchQueryDefaults,
} satisfies ApolloClient.DefaultOptions
